<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('transactions')"
      :columns="columns"
      :column_search="true"
      resource_url="/visanet_payment/transaction/datatables"
    >
      <template v-slot:buttons>
        <!-- <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("add") }}</span>
        </button> -->
      </template>
    </generic-table>
  </div>
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  error_message,
  format_currency,
} from "@/utils";

export default {
  name: "ProvidersDatatable",
  components: { GenericTable },
  data() {
    let v = this;
    return {
      columns: [
        {
          title: v.$t("profile"),
          searchable: false,
          width: "20%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return row.profile.name || "";
          },
        },
        {
          title: v.$t("card number"),
          name: "card_number",
          width: "20%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return row.card_number || "";
          },
        },
        {
          title: v.$t("total"),
          name: "total",
          width: "20%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return format_currency(row.total) || "";
          },
        },
        {
          title: v.$t("status"),
          searchable: false,
          width: "20%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return row.status_code || "";
          },
        },
        // {
        //   title: v.$t("library"),
        //   // name: "name",
        //   searchable: false,
        //   width: "35%",
        //   data: (row) => {
        //     // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
        //     return JSON.stringify(row, null, 2) || "";
        //   },
        // },
        {
          title: v.$t("options"),
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              // {
              //   args: { uuid: row.uuid },
              //   tooltip: v.$t("edit"),
              //   icon: "fa fa-edit",
              //   icon_class: "is-small",
              //   click: function (e) {
              //     // console.log("edit order", e.detail.uuid);
              //     v.$refs.provider_modal.show_modal(e.detail.uuid);
              //   },
              // },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete transaction?"),
                    v,
                    () => {
                      del("/visanet_payment/transaction", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    format_currency,
    create() {
      let v = this;
      v.$refs.provider_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
